import {
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { AccountUser, AccountAgent } from "./account-records";
import { PersonCircle } from "./person-circle";
import { AccountPairView } from "./account-pair";

export function AccountTriggerContent({
  anchor,
  user,
  agent,
}: {
  readonly anchor: "masthead" | "rail";
  readonly user: AccountUser | null;
  readonly agent: AccountAgent | null;
}) {
  return (
    <span {...stylex.props(styles.triggerContent)}>
      {anchor === "rail" ? (
        <>
          <PersonCircle user={user} />
          <span {...stylex.props(styles.name)}>
            {user?.name ?? user?.email}
          </span>
        </>
      ) : agent ? (
        <>
          <span {...stylex.props(styles.name, styles.pairLabel)}>
            {agent.player} &amp; {agent.label}
          </span>
          <AccountPairView user={user} agent={agent} />
        </>
      ) : (
        <PersonCircle user={user} />
      )}
    </span>
  );
}

const styles = stylex.create({
  name: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    lineHeight: "18px",
  },
  pairLabel: {
    display: { default: "none", "@media (min-width: 640px)": "inline" },
    maxWidth: 220,
  },
  triggerContent: {
    display: "flex",
    minWidth: 0,
    alignItems: "center",
    gap: spacing.space8,
  },
});
